import type { EmployeeStampProgress } from "@peer-start/platform-contracts";
import { CheckCircle2, CircleDashed } from "lucide-react";
import { useTranslation } from "react-i18next";

export function EvidenceFacets({ progress }: { progress: EmployeeStampProgress }) {
  const { t } = useTranslation();
  return (
    <dl className="flex flex-wrap gap-2">
      {(["knowledge", "practice", "behaviour"] as const).map((facet) => {
        const satisfied = progress.facets[facet].satisfied;
        return (
          <div
            className={`flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${
              satisfied
                ? "border-success/30 bg-success/10 text-success-foreground"
                : "border-border bg-muted text-muted-foreground"
            }`}
            key={facet}
          >
            <dt className="flex items-center gap-1.5">
              {satisfied ? (
                <CheckCircle2 aria-hidden="true" className="size-4 text-success-foreground" />
              ) : (
                <CircleDashed aria-hidden="true" className="size-4 text-muted-foreground" />
              )}
              {t(`passportVig.facets.${facet}`)}
            </dt>
            <dd className="sr-only">
              — {t(satisfied ? "passportVig.facets.satisfied" : "passportVig.facets.missing")}
            </dd>
          </div>
        );
      })}
    </dl>
  );
}
